/**
 * Detect the error a lazy `import()` raises when its chunk is gone.
 *
 * After a deploy, a client still running the previous build asks for chunk
 * names that no longer exist. Each browser words the failure differently, so
 * the route error boundary uses this to tell a stale build (auto-reload) from
 * a genuine render error (recovery panel).
 */

// Chrome/Edge, Safari, Firefox and webpack-style wording, plus Vite's
// modulepreload helper ("Unable to preload CSS for …"). The host's SPA fallback
// answers a missing chunk with index.html, which Safari rejects with
// "'text/html' is not a valid JavaScript MIME type."; the quoted type depends
// on the host or proxy, so any MIME type is accepted.
const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS|Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|is not a valid JavaScript MIME type/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.name === "ChunkLoadError" || CHUNK_LOAD_ERROR.test(error.message);
}
